<div class="modal-body">
  <iframe class="full-frame" [ngStyle]="{'height': (mainService.resizeInfo.clientHeight - 180) + 'px'}" [srcdoc]="mainService.getSafeHtml(html)"></iframe>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-info" (click)="bsModalRef.hide()">Terug</button>
</div>